import { render, staticRenderFns } from "./LeadStatusView.vue?vue&type=template&id=5352bf90&"
import script from "./LeadStatusView.vue?vue&type=script&lang=js&"
export * from "./LeadStatusView.vue?vue&type=script&lang=js&"
import style0 from "./LeadStatusView.vue?vue&type=style&index=0&id=5352bf90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports